import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ConfigStateService } from '@abp/ng.core';

import { isNullOrUndefined } from '@nexweb/util';

@Component({
  selector: 'nexweb-message-inbox',
  templateUrl: './message-inbox.component.html',
  imports: [RouterLink, AsyncPipe],
})
export class MessageInboxComponent implements OnInit {
  public configStateService = inject(ConfigStateService);

  public enableMessageInbox: boolean;
  public currentUser$ = this.configStateService.getOne$('currentUser');

  ngOnInit(): void {
    if (!isNullOrUndefined(this.configStateService.getSetting('Mdd.EnableMessageInbox'))) {
      this.enableMessageInbox = JSON.parse(this.configStateService.getSetting('Mdd.EnableMessageInbox'));
    }
  }
}
